import {SVGProps} from 'react';

type Direction = 'up' | 'down' | 'left' | 'right';
interface Props extends SVGProps<SVGSVGElement> {
    direction?: Direction;
}

export const Chevron: React.FC<React.PropsWithChildren<Props>> = ({
    width = 20,
    height = 20,
    direction = 'up',
    ...props
}) => {
    const rotation: Record<Direction, string> = {
        up: 'rotate(180deg)',
        down: 'rotate(0deg)',
        left: 'rotate(270deg)',
        right: 'rotate(90deg)',
    };

    const color = props.color || '#FFF';
    return (
        <svg
            width={width}
            height={height}
            fill="none"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
            style={{transform: rotation[direction], ...props.style}}
        >
            <path
                d="M4.756 8.09l4.655 4.654a.832.832 0 001.178 0l4.655-4.655a.833.833 0 00-.589-1.422h-9.31a.833.833 0 00-.589 1.422z"
                fill={color}
            />
        </svg>
    );
};
